;(function() {
  'use strict'

  angular.module('app.core').component('channelTypeGrid', {
    controller: Controller,
    templateUrl: 'channel-type-grid.html',
    bindings: {
      types: '<',
      onSelect: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // ...
    }
  }
})()
